import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const usePredefinedSearchReducer = () => useSelector((state: ApplicationState) => state.predefinedSearch);
